<template>
  <div
    class="wrap first"
    style="background: url('../assets/index/banner1.png')"
  >
    <div class="swiperWrap" v-if="active == 0">
      <swiper
        ref="mySwiper"
        class="swiper"
        :slides-per-view="slidenum"
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <!-- 视频 -->
        <swiper-slide
          style="position: relative"
          v-for="(item, index) in datalist"
          :key="index"
        >
          <div class="contentWrap">
            <div class="content animate__animated animate__fadeIn">
              {{ item.desc }}
            </div>
            <div
              @click="$router.push({ name: item.jump })"
              class="btn animate__animated animate__fadeIn delay2"
              @mouseover="jyb = require('../assets/index/btnAc.png')"
              @mouseleave="jyb = require('../assets/index/btn.png')"
            >
              <img :src="jyb" alt="" />
              <div>进一步了解</div>
            </div>
          </div>
          <video
            v-if="item.type == `video`"
            preload="auto"
            autoplay="autoplay"
            muted
            loop
            style="width: 100%; height: 100%; object-fit: cover; z-index: -1"
            ref="videoId"
          >
            <source :src="`${item.file}`" type="video/mp4" />
          </video>
          <img
            v-else-if="item.type == `image`"
            :src="`${item.file}`"
            mode="center"
            alt=""
          />
        </swiper-slide>

        <div
          class="swiper-pagination swiper-pagination-bullets"
          slot="pagination"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
  EffectCoverflow,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
  EffectCoverflow,
]);
import { index } from "../api/request";

export default {
  name: "Home",
  components: { Swiper, SwiperSlide },
  props: {
    index: {
      default: 0,
    },
  },
  data() {
    return {
      isMobile: this.$isMobile,
      slidenum: 0,

      bannerlist: [],
      video: [],
      datalist: [],
      // isMobile: this.$isMobile,

      banner1: {
        backgroundImage: "url(" + require("../assets/index/banner1.png") + ")",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      },
      banner2: {
        backgroundImage: "url(" + require("../assets/index/banner2.png") + ")",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      },
      banner3: {
        backgroundImage: "url(" + require("../assets/index/banner3.png") + ")",
        backgroundSize: "cover",
        backgroundCover: "cover",
      },
      jyb: require("../assets/index/btn.png"),
      active: 0,
      x: 0,
      activeIndex: 0,
      orgAmount: [
        { name: "我是标题一" },
        { name: "我是标题二" },
        { name: "我是标题三" },
      ],
      animateUp: false,
      monthSwiper: null,
      swiperOption: {
        effect: "freeMode",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: false,
        loop: true,
        pagination: {
          paginationType: "custom",
          el: ".swiper-pagination",
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
          clickable: true,
        },
        //滑动速度
        speed: 1000,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    index(val) {
      // console.log(val);
      this.active = val;
    },
  },
  mounted() {
    setInterval(this.autoLoop, 10000);
    index().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.datalist = res.data.data.banner;
        this.slidenum = res.data.data.banner.length;
        // console.log(this.slidenum);
        // this.video = this.datalist.slice(0, 1);
        // console.log(this.video);

        // this.bannerlist = this.datalist.splice(1);
        // console.log(this.bannerlist);
      }
    });
  },
  methods: {
    changebtn() {
      this.jyb = require("../assets/index/btnAc.png");
    },
    changeIndex(index) {
      index = index % 3;
      // console.log("changeiNDEX,", index);
      if (index < this.activeIndex) {
        // console.log("qian");
        this.x = -300 * index;
      } else {
        // console.log("hou");
        this.x = -300 * index;
      }
      // console.log(this.x);
      this.swiper.slideTo(index, 1000, false);
      // this.$refs.mySwiper.swiper.slideTo(index, 1000, true);
    },
    autoLoop() {
      // 无缝滚动方法
      // 假如外边需要重新触发时，则需要重新执行里面的定时器，因此需要清楚掉，再重新计时
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.animateUp = true; // 触发css样式向上滑动，实现先滑动再改变
      // 同时开启定时器，需要先等待2.5s后再执行（使用该定时器的主要原因）
      this.timer = setTimeout(() => {
        this.animateUp = !this.animateUp;
        this.orgAmount.push(this.orgAmount[0]);
        this.orgAmount.shift();
      }, 10000);
      // console.log(1)
    },
    //举个例子
    onSwiper(swiper) {
      this.activeIndex = swiper.index;
      // console.log(this.activeIndex);
    },
    onSlideChange(e) {
      this.activeIndex = e.realIndex;
      // console.log(this.activeIndex);
    },
  },
};
</script>
<style lang="less">
.first {
  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    bottom: 60px;
  }
  .my-bullet {
    margin: 0 17px;
    width: 121px;
    height: 3px;
    display: block;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.4);
  }
  .my-bullet-active {
    background: #ffffff;
  }
}
</style>
<style scoped lang="less">
.wrap {
  padding: 1px;
  position: relative;
  height: 95vh;
  width: 100%;
  color: #ffffff;
}

.line {
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
.swiper {
  position: absolute;
  right: 0;
  top: 0%;
  width: 100%;
  height: 95vh;
}
.swiper-slide {
  width: 100% !important;
  height: 95vh !important;
  img {
    width: 100% !important;
    height: 95vh !important;
  }
  .contentWrap {
    z-index: 10;
    position: absolute;
    left: 13%;
    top: 25%;
  }
  .content {
    font-size: 60px;
    text-align: left;
    font-family: 微软雅黑, MicrosoftYaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 77px;
  }
  .subcont {
    margin-top: 30px;
    font-size: 42px;
    text-align: left;
    font-family: 微软雅黑, MicrosoftYaHei;
    color: #ffffff;
  }
  .btn {
    display: flex;
    align-items: center;
    margin-top: 48px;
    img {
      margin-right: 18px;
      width: 70px !important;
      height: 70px !important;
      border-right: 500px;
    }
  }
}
.swiperWrap {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 890px;
  .bigTitle {
    overflow: hidden;
    z-index: 2;
    position: absolute;
    top: 120px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
  .father {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden; //超出部分进行隐藏
  }
  .move {
    transition: all 2.5s; //设置过渡动画
  }
  .active {
    transition: all 1s; //设置过渡动画
    opacity: 1;
  }
  .normal {
    opacity: 0.5;
    transition: all 1s; //设置过渡动画
    &:hover {
      opacity: 1;
      transition: all 1s; //设置过渡动画
    }
  }
  .children {
    width: 400px;
    font-size: 45px;
    font-weight: 500;
  }
}
/deep/.swiper-button-next,
.swiper-button-prev {
  position: unset;
  display: unset;
  color: unset;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  display: none !important;
}
.middle {
  position: relative;
  margin: 168px 0 0 521px;
  .logo {
    width: 211px;
    height: 44px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    text-align: left;
    z-index: 2001;
    position: absolute;
    top: 32px;
    left: -100px;
    font-size: 62px;
    font-family: 微软雅黑, MicrosoftYaHei;
    font-weight: 800;
    color: #ffffff;
  }
  .ball {
    margin-top: 400px;
    width: 104px;
    height: 88px;
    transition: all 5s; //设置过渡动画
    transform: rotate(360deg);
    img {
      width: 100%;
      height: 100%;
    }
  }
}
@media screen and (max-width: 450px) {
  .swiper-slide {
    .contentWrap {
      top: 10%;
    }
    .content {
      font-size: 120px;
      text-align: left;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: unset;
    }
    .subcont {
      margin-top: 30px;
      font-size: 84px;
      text-align: left;
      font-family: 微软雅黑, MicrosoftYaHei;
      color: #ffffff;
    }
    .btn {
      display: flex;
      align-items: center;
      margin-top: 48px;
      div {
        font-size: 72px;
      }
      img {
        margin-right: 18px;
        width: 140 * 1.5px !important;
        height: 140 * 1.5px !important;
        border-right: 500px;
      }
    }
  }
}
</style>
